import { CommonModule } from '@angular/common';
import {
  Component,
  Input,
  Output,
  EventEmitter,
  ChangeDetectionStrategy,
} from '@angular/core';
import { Router } from '@angular/router';
import { NgModule } from '@angular/core';

@Component({
  selector: 'app-enrollment-response',
  imports: [CommonModule],
  templateUrl: './enrollment-response.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./enrollment-response.component.scss'],
})
export class EnrollmentResponseComponent {
  @Input() data: any;
  @Output() closePopup = new EventEmitter<void>();

  constructor(private router: Router) {}
  close() {
    this.closePopup.emit();
    // Logic to close the popup
    // For example, you can use a flag in the parent component to hide the popup
  }
}
